var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$can({ key: 'clients', expectedPermission: 'edit' }))?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('router-link',{staticClass:"btn btn-outline-blue mb-3",attrs:{"to":{
          name: 'tasks.add',
          query: { taskType: '7', userId: _vm.patients.patient.user_id },
        }}},[_c('icon',{attrs:{"type":"plus"}}),_vm._v(" Add Note ")],1)],1)]):_vm._e(),_c('timeline',{attrs:{"userId":_vm.patients.patient.user_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }